<template>
<div class="civii-upload" v-if="uploadWidget">
  <input ref="upload" type="file" accept="image/png,image/jpeg" >
  <cancelaccept class="cancelaccept" @accept="accept" @cancel="cancel" />
</div>
</template>

<script>
import cancelaccept from './../CancelAccept/CancelAccept.vue'

export default {
  components: {
    cancelaccept
  },
  data () {
    return {
      reader: null
    }
  },
  methods: {
    async accept () {
      let file = this.$refs.upload.files[0]
      this.reader = new FileReader()
      this.reader.addEventListener('load', this.accept_)
      this.reader.readAsDataURL(file)
    },
    accept_ () {
      if (this.reader.result.length > (1500000 * 1.35)) {
        this.$store.commit('addToContext', {'_input': {error: 'size'}})
      } else {
        this.$store.commit('addToContext', {'_input': this.reader.result})
      }
      this.$store.dispatch('sendMessage', {})
    },
    async cancel () {
      this.$store.commit('addToContext', {'_input': false})
      await this.$store.dispatch('sendMessage', {})
    }
  },
  computed: {
    uploadWidget () {
      return this.$store.state.uploadWidget
    }
  },
  watch: {
    uploadWidget (value) {
      if (value) {
        let self = this
        this.$nextTick(function () {
          self.$refs.upload.click()
        })
      }
    }
  }
}
</script>

<style lang="less">
.civii-upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/UploadWidget/UploadWidget.vue